export default import.meta.ROLLDOWN_FILE_URL_F_8o7K1uLMdL2ec3XGzqDw